var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z",
    fill: "#8484FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6176 31.1134L31.0588 32.6757C30.8529 32.8821 30.5882 33 30.2941 33C30 33 29.7353 32.8821 29.5294 32.6757L16.5 19.6466C16.1471 19.7645 15.7647 19.7939 15.4118 19.8234C14.7059 19.8234 14.0294 19.6466 13.4118 19.3223C12.7941 18.998 12.2647 18.5264 11.8529 17.9663C11.4412 17.4062 11.1765 16.7282 11.0882 16.0503C11 15.3723 11.0588 14.6648 11.2941 13.9868L14.0882 16.7872L14.6765 16.1976L16.2353 14.6353L16.8235 14.0458L14.0294 11.2454C14.6765 11.0096 15.3824 10.9506 16.0882 11.039C16.7647 11.1275 17.4412 11.3928 18 11.8055C18.5588 12.2181 19.0294 12.7487 19.3529 13.3678C19.6765 13.9868 19.8529 14.6648 19.8529 15.3723C19.8529 15.7555 19.7941 16.1092 19.6765 16.4629L32.6765 29.4921C32.8824 29.6985 33 29.9638 33 30.2586C32.9118 30.6123 32.7941 30.9071 32.6176 31.1134ZM11.3235 29.5511C11.1176 29.7574 11 30.0227 11 30.3175C11 30.6123 11.1176 30.8776 11.3235 31.0839L12.8824 32.6463C13.0882 32.8526 13.3529 32.9705 13.6471 32.9705C13.9412 32.9705 14.2059 32.8526 14.4118 32.6463L20.4118 26.6623L17.3235 23.5671L11.3235 29.5511ZM30.7353 11.039L26.3529 13.2204V15.4017L23.9706 17.7895L26.1471 19.9708L28.5294 17.5831H30.7059L32.8823 13.1909L30.7353 11.039Z",
    fill: "#8484FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarService);
export default __webpack_public_path__ + "static/media/43f5c4b2cffabc34a78391d8b81fb3ccb000379cef.svg";
export { ForwardRef as ReactComponent };